import { Button, Typography, Box, Avatar, Badge, Menu } from '@mui/material'
import { Stack } from '@mui/system'
import React from 'react'
import { Link, useParams } from 'react-router-dom'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import FavoriteIcon from '@mui/icons-material/Favorite'
import ShareIcon from '@mui/icons-material/Share'
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd'
import PauseIcon from '@mui/icons-material/Pause';
import { useGetUserQuery, useLikeByTypeMutation } from '../../api/userApiSlice'
import SubscribeAMPopup from '../dialog/SubscribeAMPopup'
import { pause, playTrack } from '../../services/MusicPlayerApi'
import MoreVertSharpIcon from '@mui/icons-material/MoreVertSharp'
import PianoIcon from '@mui/icons-material/Piano'
import withMK from '../../hoc/withMK'
import { useDispatch } from 'react-redux'
import { setAddPlaylistTrack } from '../../actions/artistSlice'
import { setShowSubscribe } from '../../actions/mainSlice'

interface TrackRowProps extends MKProps {
    track: Track,
    index: number,
    maxProducers: number,
    fromAlbum: Boolean,
    color: string,
    onClick: any
}


const TrackRow = (props: TrackRowProps) => {
    let {track, index, maxProducers = 2, fromAlbum, color = '#FFFFFF', onClick, mk} = props
    let { id } = useParams()
    const [likeTrack] = useLikeByTypeMutation()
    const [openAM, setOpenAM] = React.useState(false)
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const [anchorElProd, setAnchorElProd] = React.useState<null | HTMLElement>(null)
    const openMenu = Boolean(anchorEl)
    const openProducersMenu = Boolean(anchorElProd)
    const currentTrackId = mk && mk.instance.queue.currentItem ? mk.instance.queue.currentItem.id : null
    const playing = mk?.instance?.isPlaying
    let dispatch = useDispatch()
    

    const {
        data: user
    } = useGetUserQuery({})

    const openSubscribePopup = () => {
        dispatch(setShowSubscribe({showSubscribe: true}))
    }
    
    const handleClose = () => {
        setOpenAM(false)
    }

    const handleCloseMenu = () => {
        setAnchorEl(null)
    }

    const handleCloseProdMenu = () => {
        setAnchorElProd(null)
    }
    
    const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClickProducersMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElProd(event.currentTarget)
    }

    const likeTrackById = async (ID: String) => {
        try {
            var likedTrack: any = await likeTrack({ target_id: ID, type: 'track' })
            if (likedTrack.error) {
                openSubscribePopup()
            } else {
                
            }
        } catch (err) {
            console.log(err)
        }
    }

    const addTrackToPlaylistById = async (track: Track) => {
        if (user)
            dispatch(setAddPlaylistTrack({track: track}))
        else
            dispatch(setShowSubscribe({showSubscribe: true}))
    }

    return <Box sx={{width: '100%', position: 'relative' }} >
        <SubscribeAMPopup handleClose={handleClose} open={openAM} onClick={onClick} />
        <Stack direction="row" sx={{p: 1}} alignItems={'center'}>
            { 
                fromAlbum
                ?   playing && track.apple_id+'' === currentTrackId+''
                    ? <Badge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        badgeContent={
                            <PauseIcon htmlColor='#fff'  onClick={() => pause()} sx={{background: '#17043d',border: '4px solid #17043d', borderRadius: '50%', fontSize: '16pt'}}  />
                        }
                    >
                        <Typography variant='h4' sx={{color: color, width: '5vw', textAlign: 'left'}}>{index+1}</Typography>
                    </Badge>
                    : <Badge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        badgeContent={
                            <PlayArrowIcon 
                                onClick={() => playTrack([new MusicKit.MediaItem({type: 'song', id: track.apple_id+''})], 0)} 
                                htmlColor='#fff' 
                                sx={{background: '#17043d',border: '4px solid #17043d', borderRadius: '50%', fontSize: '16pt'}} />
                        }
                    >
                        <Typography variant='h4' sx={{color: color, width: '5vw', textAlign: 'left'}}>{index+1}</Typography>
                    </Badge>
                : playing && track.apple_id+'' === currentTrackId+''
                    ? <Badge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        badgeContent={
                            <PauseIcon htmlColor='#fff' onClick={() => pause()} sx={{background: '#17043d',border: '4px solid #17043d', borderRadius: '50%', fontSize: '16pt'}}  />
                        }
                    >
                        <Avatar 
                            onClick={() => pause()}
                            variant="rounded" 
                            alt={track.album.apple_name} 
                            src={track.album.apple_artwork_url?.replace("{w}","1200")?.replace("{h}","800")} 
                            sx={{width: '6vh', height: '6vh' }} />
                    </Badge>
                    : <Badge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        badgeContent={
                            <PlayArrowIcon 
                                onClick={() => playTrack([new MusicKit.MediaItem({type: 'song', id: track.apple_id+''})], 0)} 
                                htmlColor='#fff' 
                                sx={{background: '#17043d',border: '4px solid #17043d', borderRadius: '50%', fontSize: '16pt'}} />
                        }
                    >
                        <Avatar 
                            onClick={() => playTrack([new MusicKit.MediaItem({type: 'song', id: track.apple_id+''})], 0)}
                            variant="rounded" 
                            alt={track?.album?.apple_name} 
                            src={track?.album?.apple_artwork_url?.replace("{w}","1200")?.replace("{h}","800")} 
                            sx={{ width: '6vh', height: '6vh' }} />
                    </Badge>

            }
            <Stack justifyContent="center" sx={{ marginLeft: '16px', width: '100%', color: 'white', '& a' : { textDecorationColor: color} }}>
                <Link to={`/track/${track._id}`} >
                    <Typography sx={{fontWeight: 500, fontSize: '1rem', color: color}}>{`${track.apple_title_clear.slice(0, 34)}${track.apple_title_clear.length > 34 ? '...' : ''}`}</Typography>
                </Link>
                <Stack direction="row" alignItems={'baseline'}>
                    <Stack direction={"row"} sx={{color: color}}>
                        {
                            track && track.main_artists.map((artist, i) => {
                                return i === track.main_artists.length - 1
                                    ? artist._id === id ? artist.artist_name : <Link key={Date.now() + i + artist._id} to={`/artist/${artist._id}`} > <Typography sx={{color: color, display: 'inline'}}>{artist.artist_name}</Typography> </Link>
                                    : artist._id === id ? artist.artist_name + ', ' : <span key={Date.now() + i + artist._id}><Link key={Date.now() + i + artist._id} to={`/artist/${artist._id}`} > <Typography sx={{color: color, display: 'inline'}}>{artist.artist_name}</Typography> </Link>, </span>
                            })
                        }
                    </Stack>
                    {
                        track?.featured_artists && track?.featured_artists?.length > 0
                            ?
                            <Stack direction={"row"} sx={{color: color, pl: 1}}><span>ft.</span> {track.featured_artists.slice(0, 6).map((artist, i) => {
                                return track?.featured_artists && i === track.featured_artists.length - 1
                                    ? artist._id === id ? artist.artist_name : <Link key={Date.now() + i + artist._id} to={`/artist/${artist._id}`} > <Typography sx={{color: color, display: 'inline', pl: 1}}>{artist.artist_name}</Typography> </Link>
                                    : artist._id === id ? artist.artist_name + ', ' : <span key={Date.now() + i + artist._id}><Link to={`/artist/${artist._id}`} > <Typography sx={{color: color, display: 'inline', pl: 1}}>{artist.artist_name}</Typography> </Link>, </span>
                            }
                            )}
                            </Stack>
                            : ''
                    }
                </Stack>
                <Box sx={{minHeight: '2vh', maxHeight: '4vh', overflow: 'hidden'}}>
                    {
                        track.producers !== null && track.producers.length > 0
                            ?
                            <Box sx={{color: color, display: 'block', textAlign: 'right',  fontWeight: 400, fontSize: '0.8rem'}}>{track.producers.slice(0,maxProducers).map((artist, i) => {
                                return track.producers && i === Math.min(maxProducers - 1, track.producers.length - 1)
                                    ? artist._id === id 
                                        ? artist.artist_name + (track.producers!.length >= maxProducers ? ',...' : '') 
                                        : <Stack key={i} direction={'row'} sx={{display: 'inline'}}>
                                            <Link to={`/artist/${artist._id}`} ><Typography sx={{color: color, display: 'inline'}}> {artist.artist_name}</Typography> </Link>
                                            <Typography sx={{color: color, display: 'inline'}}>{ (track.producers!.length > maxProducers ? ',...' : '') }</Typography>
                                        </Stack>
                                    : artist._id === id 
                                        ? <Typography key={Date.now() + i + artist._id} sx={{color: color, display: 'inline'}}>{artist.artist_name + ', ' }</Typography>
                                        : <span key={Date.now() + i + artist._id}><Link to={`/artist/${artist._id}`} ><Typography sx={{color: color, display: 'inline'}}>{artist.artist_name}</Typography> </Link>, </span>
                            }
                            )}
                            </Box>
                            : ''
                    }
                </Box>
            </Stack>
            <Menu
                id="actions-menu"
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleCloseMenu}
            >
                {
                    track.producers && track.producers.length >= 3 
                    ?
                    <Button onClick={handleClickProducersMenu} key={5}><PianoIcon htmlColor='#17043d' /></Button>
                    : ''
                }
                {
                    playing && track.apple_id+'' === currentTrackId+''
                        ? <Button key={8}  onClick={() => pause()} ><PauseIcon htmlColor='#17043d' /></Button>
                        : <Button key={8}  onClick={() => playTrack([new MusicKit.MediaItem({type: 'song', id: track.apple_id+''})], 0)} ><PlayArrowIcon htmlColor='#17043d' /></Button>

                }
                <Button key={7} onClick={() => addTrackToPlaylistById(track)}><PlaylistAddIcon htmlColor='#17043d' /></Button>
                <Button key={6}  onClick={() => likeTrackById(track._id)} ><FavoriteIcon htmlColor='#17043d' /></Button>
                <Button key={11} ><ShareIcon htmlColor='#17043d' /></Button>
            </Menu>
            <Menu
                id="producers-menu"
                anchorEl={anchorElProd}
                open={openProducersMenu}
                onClose={handleCloseProdMenu}
            >
                {
                    track.producers !== null && track.producers.length > 0
                        ? <Box sx={{color: '#17043d', display: 'block', textAlign: 'right', whiteSpace: 'nowrap', pl: 2, pr: 2}}>
                            {
                                track.producers.map((artist, i) => {
                                return track.producers && i === track.producers.length - 1
                                    ? artist._id === id 
                                        ? <Typography key={Date.now() + i + artist._id} sx={{color: '#17043d', display: 'inline'}}>{artist.artist_name}</Typography>
                                        : <Link key={Date.now() + i + artist._id} to={`/artist/${artist._id}`} > <Typography sx={{color: '#17043d', display: 'inline'}}>{artist.artist_name}</Typography> </Link>
                                    : artist._id === id 
                                        ? <Typography key={Date.now() + i + artist._id} sx={{color: '#17043d', display: 'inline'}}>{(artist.artist_name + ', ' ) }</Typography>
                                        : <span key={Date.now() + i + artist._id}><Link to={`/artist/${artist._id}`} > <Typography sx={{color: '#17043d', display: 'inline'}}>{artist.artist_name} </Typography></Link>, </span>
                                })
                            }
                        </Box>
                        : ''
                }
            </Menu>
            <Stack direction="row" justifySelf={'flex-end'}>
                <Button key={10} color="secondary" onClick={handleClickMenu} sx={{textAlign: 'right', p: 0, m: 0, minWidth: 0}}><MoreVertSharpIcon viewBox={'0 0 4 24'} htmlColor={color} /></Button>
            </Stack>
        </Stack>
    </Box>
}


const bindings = {
    [MusicKit.Events.mediaItemDidChange]: 'mediaItem',
    [MusicKit.Events.queueItemsDidChange]: 'queueItems',
    [MusicKit.Events.queuePositionDidChange]: 'queuePosition',
    [MusicKit.Events.playbackStateDidChange]: 'playbackState',
}
  
export default withMK(TrackRow, bindings)